// frontend/i18n/useTranslation.ts

import { useRestaurant } from "../app/context/RestaurantContext";
import { t, getTranslations, availableLanguages } from "./index";

export function useTranslation() {
    const { language } = useRestaurant();

    return {
        t: (key: string, params?: Record<string, string | number>) => t(language || "es", key, params),
        translations: getTranslations(language),
        language,
        availableLanguages,
    };
}